module.exports = __webpack_public_path__ + "img/v4_serverLanguageService.f24e54e8.png";